"use client";

import { useState, type InputHTMLAttributes } from "react";
import { css, cx } from "styled-system/css";
import { Eye, EyeOff } from "lucide-react";

/** Input de contraseña con ícono para mostrar/ocultar el texto en plano. */
export function PasswordInput({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={css({ position: "relative", width: "100%" })}>
      <input
        type={visible ? "text" : "password"}
        className={cx(className, css({ width: "100%", pr: "11" }))}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        onClick={() => setVisible((v) => !v)}
        className={css({
          position: "absolute",
          right: "3",
          top: "50%",
          transform: "translateY(-50%)",
          display: "flex",
          alignItems: "center",
          bg: "transparent",
          border: "none",
          cursor: "pointer",
          color: "#94a3b8",
          p: "1",
          _hover: { color: "#64748b" },
        })}
      >
        {visible ? <EyeOff size={18} strokeWidth={1.75} aria-hidden /> : <Eye size={18} strokeWidth={1.75} aria-hidden />}
      </button>
    </div>
  );
}
